import { clsx } from 'clsx';
import { TabsContent } from 'src/components/ui/tabs';
import { PersonaForm } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/PersonaForm';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { PersonaTabSkeleton } from 'src/pages/ConfigurationPage/PersonaTab/PersonaTabSkeleton/PersonaTabSkeleton';
import type { ConfigurationFormFieldsObject } from 'src/pages/ConfigurationPage/hooks/useConfigurationFormFields';
import type { PersonaInputData } from 'src/pages/ConfigurationPage/utils/getPersonaFormValues';
import { CustomConfigurationMessage } from 'src/components/CustomConfigurationMessage/CustomConfigurationMessage';

export const PersonaTab = ({
  isCustomActiveSettings = false,
  formFieldsObject = {},
  inputData = {},
  readonly,
  isLoading = false,
}: {
  isCustomActiveSettings?: boolean;
  formFieldsObject?: ConfigurationFormFieldsObject;
  inputData?: PersonaInputData | null;
  readonly?: boolean;
  isLoading?: boolean;
}) => {
  const formFieldsLength = Object.keys(formFieldsObject).length;

  return (
    <TabsContent
      className={clsx('py-2 mt-0 h-full rounded-sm-5 overflow-auto pr-2')}
      value={'persona'}
    >
      <LoaderWrapper isLoading={isLoading} loader={<PersonaTabSkeleton />}>
        {Boolean(formFieldsLength) && !isCustomActiveSettings ? (
          <PersonaForm
            formFieldsObject={formFieldsObject}
            inputData={inputData}
            readonly={readonly}
            compact={true}
          />
        ) : (
          <CustomConfigurationMessage />
        )}
      </LoaderWrapper>
    </TabsContent>
  );
};
